<template>
  <a 
  href="/recruit/" 
  class="c-btnRecruit"
  :class="{'isEnter': isEnter}"
  @mouseenter="onHover"
  @mouseleave="onHover"
  >
    <div class="c-btnRecruit__text">
      <span class="c-btnRecruit__textEn">{{textEn}}</span>
      <span class="c-btnRecruit__textJa" v-html="textJa"></span>
    </div>
    <div class="c-btnRecruit__arrow"></div>
  </a>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import { TweenMax } from 'gsap';

  export default {
    props: ['textEn', 'textJa'],
    data() {
      return {
        assets_path: assets_path,
        isEnter: false,
        isOver: false,
        isPlaying: false
      }
    },
    store,
    computed: {
    },
    mounted() {
      console.log('btn recruit', this);
    },
    methods: {
      onHover(e) {
        if (e.type === 'mouseenter') {
          this.rollOver();
        } else if (e.type === 'mouseleave') {
          this.rollOut();
        }
      },
      rollOver() {
        this.isOver = true;
        if (!this.isPlaying) {
          this.startRollOver();
        }
      },
      startRollOver() {
        this.isPlaying = true;
        this.isEnter = true;
        TweenMax.delayedCall(0.4, this.completeRollOver);
      },
      completeRollOver() {
        this.isPlaying = false;
        if(!this.isOver) {
          this.startRollOut();
        }
      },
      rollOut() {
        this.isOver = false;
        if (!this.isPlaying) {
          this.startRollOut();
        }
      },
      startRollOut() {
        this.isPlaying = true;
        this.isEnter = false;
        TweenMax.delayedCall(0.4, this.completeRollOut);
      },
      completeRollOut() {
        this.isPlaying = false;
        if(this.isOver) {
          this.startRollOver();
        }
      }
    }
  }
</script>
